<div class="container-fluid py-4">
  <div class="row mb-4 justify-content-center">
    <ng-container *ngFor="let card of resumenCards; index as i">
      <div class="col-3 col-md-2">
        <div
          class="card card-stats"
          [ngClass]="{ 'card-stats__selected': i === 0 }"
          [routerLink]="card.route"
          [style.cursor]="card.route || i === 0 ? 'pointer' : 'default'"
        >
          <div class="card-body">
            <div class="row">
              <div class="col-12 col-md-6 col-lg-6">
                <div
                  class="icon-big text-center text-dark rounded shadow icon-card"
                  [ngClass]="card.bgClass"
                >
                  <i [class]="card.icon"></i>
                </div>
              </div>

              <div class="col-7 d-flex flex-column justify-content-center">
                <p class="card-category mb-0">{{ card.label }}</p>
                <h4
                  class="card-title mb-0"
                  [ngClass]="{ 'text-dark': i === 0, 'text-white': i !== 0 }"
                >
                  {{ card.value }}
                </h4>
              </div>
            </div>
          </div>

          <div class="card-footer">
            <div class="stats">
              <small [class]="i == 0 ? 'desc__selected' : 'desc'">{{
                card.desc
              }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- SALTO DE FILA después de la 4ta tarjeta (i = 3) -->
      <div *ngIf="i === 3" class="w-100"></div>
    </ng-container>
  </div>
  <div class="row pb-4 mt-4">
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-light btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsDaily']"
        >
          Metrics daily
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/metricsWeekly']"
        >
          Metrics weekly
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/actionsBacklog']"
        >
          Actions backlog
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalClusters']"
        >
          Cannibal clusters
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/keywordInsights']"
        >
          Keyword insights
        </a>
      </div>
    </div>
    <div class="col-12 d-flex align-items-center justify-content-center">
      <div class="flex-grow-1 text-center">
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/cannibalEdges']"
        >
          Cannibal edges
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/localSeo/reviews']"
        >
          Reviews
        </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/technicalAudits']"
        >
          Technical Audits
        </a>
        <a class="btn btn-dark btn-sm btn-reg"> Sitemap Audits </a>
        <a
          class="btn btn-dark btn-sm btn-new"
          [routerLink]="['/observability/seo/offPagePerformance']"
        >
          Off-page
        </a>
      </div>
    </div>
  </div>
  <!-- <div class="row">
      <div class="col-md-12">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h2 class="title">Sitemap Audits</h2>
          <button class="btn btn-primary btn-round" (click)="runAudit()">
            <i class="material-icons">play_arrow</i> Run Audit Manually
          </button>
        </div>
      </div>
    </div> -->

  <!-- Dashboard Cards -->
  <app-sitemap-dashboard-cards
    [data]="dashboardData"
  ></app-sitemap-dashboard-cards>

  <div class="row" *ngIf="!loading; else loadingTpl">
    <!-- Main Content Area: Latest Audit Details -->
    <div class="col-lg-8 col-md-12">
      <!-- Issues Table -->
      <app-sitemap-issues-table
        [issues]="latestAudit?.issuesDetected"
      ></app-sitemap-issues-table>

      <!-- Missing URLs -->
      <app-sitemap-missing-urls [urls]="missingUrls"></app-sitemap-missing-urls>
    </div>

    <!-- Sidebar Area: History -->
    <div class="col-lg-4 col-md-12">
      <app-sitemap-history
        [history]="history"
        (selected)="onAuditSelected($event)"
      ></app-sitemap-history>
    </div>
  </div>

  <ng-template #loadingTpl>
    <div class="row">
      <div class="col-md-12 text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-2">Analyzing sitemap data...</p>
      </div>
    </div>
  </ng-template>
</div>
